import { render } from "./ManageAccount.vue?vue&type=template&id=25860e4f&scoped=true"
import script from "./ManageAccount.vue?vue&type=script&lang=js"
export * from "./ManageAccount.vue?vue&type=script&lang=js"

import "./ManageAccount.vue?vue&type=style&index=0&id=25860e4f&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25860e4f"]])

export default __exports__